const gcfDomain = 'https://us-central1-weedrater-56c26.cloudfunctions.net'
// const gcfDomain = 'http://localhost:5000/weedrater-56c26/us-central1'

export const apiSlackURL = `${gcfDomain}/slack`
export const apiDispensariesURL = `${gcfDomain}/dispensaries`
export const apiReviewsURL = `${gcfDomain}/reviews`
export const apiUsersURL = `${gcfDomain}/users`
export const apiEventsURL = `${gcfDomain}/events`
